<ng-container>
  <div>
    <button (click)="toggle()"
            [ngClass]="favorite ? 'icon-heart-fill-in':'icon-heart-empty'"
            class="btn ssab-icon icon-cursor ">
    </button>
  </div>
</ng-container>
